import { render, staticRenderFns } from "./TeamFuerzaTooltip.vue?vue&type=template&id=2f072db0&scoped=true&"
import script from "./TeamFuerzaTooltip.vue?vue&type=script&lang=js&"
export * from "./TeamFuerzaTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TeamFuerzaTooltip.vue?vue&type=style&index=0&id=2f072db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f072db0",
  null
  
)

export default component.exports